import { COUNTRIES } from "src/_mock";

type TCountryOption = {
  label: string;
  value: string;
};

export const manualDocumentCountryOptions: TCountryOption[] = COUNTRIES.map(
  (country) => ({
    label: country.label,
    value: country.code,
  }),
);

export const getManualDocumentCountryValue = (country?: string | null) => {
  if (!country) {
    return "";
  }

  const matchedOption = manualDocumentCountryOptions.find((option) => {
    const optionLabel = option.label.trim().toLowerCase();
    const optionValue = String(option.value).trim().toLowerCase();
    const searchValue = country.trim().toLowerCase();

    return optionLabel === searchValue || optionValue === searchValue;
  });

  return matchedOption?.value ?? "";
};
